import React from 'react'
import './PayAnyBillView.scss'
import _ from 'lodash'

import CONFIG from '../../../../config'

import {getLanguageScope, C, S, capitalize} from '../../../../helpers'

const _i18n = getLanguageScope('pay_any_bill');

import {Grid, Header, Form, Input, Radio, Table, Message, Label, Image, Icon, Button} from 'semantic-ui-react'
import Lightbox from 'react-images';

import Amount from '../../shared/Amounts/containers/AmountContainer'
import Navigation from '../../shared/Navigation/containers/NavigationContainer'

import ScannerDevice from '../../../../components/Devices/Scanner/containers/ScannerContainer'

import {validator} from '../models/transaction'

class PayAnyBill extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lightBoxIsOpen: false,
      openedImage: 0,
      isInputBlurred: false
    };

    this.resetScanResult = this.resetScanResult.bind(this);
    this.resetAccountNumber = this.resetAccountNumber.bind(this);
    this.updateAccountNumber = this.updateAccountNumber.bind(this)
  }

  handleChangeConfirmField = async (name,value) => {
    const { appSetVal } = this.props
    await appSetVal(name,value)
    await appSetVal('check_account_done',false)
  }

  componentDidUpdate (prevProps, prevState) {
    const { appSetVal, account, confirm_account } = this.props
    if (!_.isEmpty(account) && !_.isEmpty(confirm_account) && account === confirm_account) {
      appSetVal('isAccountFieldsEqual',true)
    } else {
      appSetVal('isAccountFieldsEqual',false)
    }
  }

  async componentDidMount() {
    const {appCall, updateAmounts, getAccounts, customer_id} = this.props;

    await appCall('setPaymentOption', 0);
    updateAmounts();

    if (customer_id) {
      await getAccounts();
    }
  }

  async componentWillReceiveProps(nextProps) {
    const {customer_id, getAccounts, appSetVal, scanned_image_front, sendBillImage, account_scanner} = this.props;

    if (nextProps.customer_id && nextProps.customer_id !== customer_id) {
      await getAccounts();
    }

    if(nextProps.scanned_image_front && nextProps.scanned_image_front !== scanned_image_front){
      await this.resetAccountNumber();

      if(nextProps.account_scanner && nextProps.account_scanner !== account_scanner){
        this.updateAccountNumber(nextProps.account_scanner)
      } else {
        sendBillImage();
      }

    }

    if (customer_id && !nextProps.customer_id) {
      await appSetVal('stored_accounts', [])
    }
  }

  async changeFee(i) {
    const {appCall, updateAmounts} = this.props;

    await appCall('setPaymentOption', i);
    updateAmounts();
  }

  renderPaymentOptions() {
    const {payment_options, payment_option_type} = this.props;

    const cells = _.map(_.compact(payment_options), (option, key) => {
      return (
        <Table.Row key={key}>
          <Table.Cell>
            <Header as='h4' image>
              <Header.Content>
                <Radio
                  label={option.priority ? _i18n('priority') : _i18n('standard')}
                  name='radioGroup'
                  value={option.i}
                  checked={payment_option_type === option.i}
                  onChange={() => this.changeFee(option.i)}
                />
              </Header.Content>
            </Header>
          </Table.Cell>
          <Table.Cell>
            {option.description}
          </Table.Cell>
          <Table.Cell>
            {C(option.fee, '$')}
          </Table.Cell>
        </Table.Row>
      )
    });

    return (
      <Table basic='very' celled collapsing>
        <Table.Body>
          {cells}
        </Table.Body>
      </Table>
    )
  }

  createRequireName(name = '') {
    return `required_${name.toLowerCase()}`;
  }

  renderRequiredInputs() {
    const {required_fields, appSetVal} = this.props;

    const requiredFieldsViews = _.map(required_fields, (field, key) => {
        const type = (field.format && field.format.charset) === 'N' ? 'number' : 'text';
        const maxLength = (field.format && field.format.length) ? field.format.length : 50;
        const fieldName = this.createRequireName(field.name);
        return (
          <Form.Field required key={key}>
            <label>{capitalize(field.description)}</label>
            <Input name={fieldName} value={this.props[fieldName]}
                   onChange={(e, {name, value}) => appSetVal(name, value)}
                   type={type} maxLength={maxLength}
                   placeholder={capitalize(field.description)}/>
          </Form.Field>
        )
      }
    );

    return (
      <Form className='mt-30'>
        {requiredFieldsViews}
      </Form>
    )
  }

  createExtraValidationModel() {
    const {required_fields} = this.props;

    if (!(required_fields && required_fields.length)) return null;

    return _.map(required_fields, (field, key) => {
      const fieldLength = (field.format && field.format.length) ? field.format.length : 20;

      return {
        field: this.createRequireName(field.name),
        type: 'string',
        validation: (v) => {
          if(_.isUndefined(v)) return false;
          const value = S(v).replace(/^\s+/g, '');

          if(field.format && field.format.charSet === 'N'){
            return value.length >= fieldLength
          }

          return value.length >= 2 && value.length <= fieldLength
        }
      }
    })
  }

  updateAccountNumber(value = '') {
    const {appSetObj} = this.props;

    appSetObj({
      account: value,
      account1: value,
      check_account_done  : false
    });
  }

  updateBothAccountNumber = (value = '') => {
    const {appSetObj} = this.props;

    appSetObj({
      account: value,
      account1: value,
      confirm_account: value,
      check_account_done  : false
    });
  }

  renderStoredAccounts() {
    const {stored_accounts} = this.props;
    if (!(stored_accounts && stored_accounts.length)) return null;

    const storedAccountViews = _.map(stored_accounts, (v, key) => {
      return (
        <Label as={'a'} onClick={() => this.updateBothAccountNumber(v)} key={key} size={'mini'}>
          {v}
        </Label>
      )
    });

    return (
      <Form style={{paddingTop: 10}}>
        <Form.Field>
          <label>{_i18n('select_account')}</label>
          {storedAccountViews}
        </Form.Field>
      </Form>
    )
  }

  async resetAccountNumber(){
    const {appSetObj, appSetServerVal} = this.props;

    await appSetObj({
      account: '',
      account1: '',
      scanner_account_error: false,
      check_account_error: false,
      bill_image_processing: false,
    });

    await appSetServerVal('image_name', '');
    await appSetServerVal('account', '');
    await appSetServerVal('account1', '');
  }

  async resetScanResult() {
    const {resetScannerResult, appSetVal} = this.props;

    await this.resetAccountNumber();

    await appSetVal('scanned_image_front', '');
    resetScannerResult();
  }

  renderAccountNumber() {
    const {
      scanned_image_front, scanned_image_back, check_account_error, bill_image_processing,
      account, confirm_account, scanner_account_error, appSetVal, isAccountFieldsEqual,
    } = this.props;

    const {lightBoxIsOpen, openedImage} = this.state;

    let alertsView = (
      <div>
        <Message visible={check_account_error} error header={_i18n('account_number_not_valid_header')}
                 content={_i18n('account_number_not_valid_content')}/>
        <Message visible={!isAccountFieldsEqual && !_.isEmpty(account) && !_.isEmpty(confirm_account) && !this.state.isInputBlurred} error header={_i18n('account_number_not_valid_header')}
                 content={_i18n('account_number_not_equal_confirm_account')}/>
        <Message visible={scanner_account_error} error header={_i18n('bill_image_processing_error_header')}
                 content={_i18n('bill_image_processing_error_content')}/>
      </div>
    );

    let accountForm = (
      <Form>
        <Form.Field required>
          <label>{_i18n('account')}</label>
          <Input 
            className={this.state.isInputBlurred ? 'blurred-input': ''} 
            onPaste={(e)=> {e.preventDefault(); return false}} 
            onCopy={(e)=> {e.preventDefault(); return false}} 
            autoComplete="off" 
            onFocus={() => this.setState({isInputBlurred: false})} 
            onChange={(e, {name, value}) => this.updateAccountNumber(value)} 
            style={{marginBottom: '15px'}}
            value={account || ''} 
            name='account'
            icon='hashtag' 
            iconPosition='left' 
            placeholder={_i18n('account')}
          />
          <label>{_i18n('confirm_account')}</label>
          <Input 
            onCopy={(e)=> {e.preventDefault(); return false}} 
            onPaste={(e)=> {e.preventDefault(); return false}}
            autoComplete="off" 
            onFocus={() => this.setState({isInputBlurred: true})} 
            onBlur={() => this.setState({isInputBlurred: false})}
            onChange={(e, {name, value}) => this.handleChangeConfirmField(name, value)} 
            value={confirm_account || ''} 
            name='confirm_account'
            icon='hashtag' 
            iconPosition='left' 
            placeholder={_i18n('confirm_account')}
          />

          {this.renderStoredAccounts()}
        </Form.Field>

        {alertsView}
      </Form>
    );

    if (scanned_image_front) {
      accountForm = (
        <Form>
          <Form.Field required>
            <Input readOnly={true} loading={bill_image_processing} value={account} name='account'
                   icon='hashtag' iconPosition='left' placeholder={_i18n('account')}/>
          </Form.Field>
          <Form.Field>
            <label>{_i18n('bill_image')}</label>

            <Image.Group size='small'>
              {_.map([scanned_image_front, /* scanned_image_back */], (image, index) => {
                return image && <Image style={{cursor: 'pointer'}} key={index} onClick={() => {
                  this.setState({lightBoxIsOpen: true, openedImage: index})
                }} src={image}/>
              })}
            </Image.Group>

            <Form.Button disabled={bill_image_processing} content={_i18n('manual_entering')} onClick={this.resetScanResult}
                    size={'tiny'} icon='write' labelPosition='right' />

            <Lightbox
              images={_.map([scanned_image_front, /*scanned_image_back*/], (image) => image && {src: image})}
              isOpen={lightBoxIsOpen}
              onClose={() => {
                this.setState({lightBoxIsOpen: false})
              }}
              backdropClosesModal={true}
              onClickPrev={() => this.setState({openedImage: openedImage - 1})}
              onClickNext={() => this.setState({openedImage: openedImage + 1})}
              currentImage={openedImage}
            />

          </Form.Field>

          {alertsView}
        </Form>
      )
    }

    return accountForm;
  }

  render() {
    const {biller_name, icon, checkFields, submitTransaction, ready_to_submit} = this.props;
   
    return (
      <Grid columns='equal'>
        <Grid.Row divided style={{'minHeight': 250}} stretched columns={2}>
          <Grid.Column>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={biller_name} as='h3'/>
                {this.renderPaymentOptions()}
                {this.renderAccountNumber()}
                {this.renderRequiredInputs()}

                <ScannerDevice scanType={'check'}/>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Amount/>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>

        <Navigation
          onSubmit={() => submitTransaction(this.createExtraValidationModel())}
          showSubmit={true}
          disabledSubmit={ready_to_submit}
          submitValidator={() => checkFields(validator, this.createExtraValidationModel())}
        />

      </Grid>
    )
  }
}

PayAnyBill.propTypes = {};

export default PayAnyBill


// WEBPACK FOOTER //
// ./src/components/Applications/PayAnyBill/components/PayAnyBillView.js